import React, { Component } from "react";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { Button } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import "../../styles/notification/notification.scss";
import moment from "moment";
import { utcToLocal } from "../../utils/dateConvert";

class NotificationDetails extends Component {

  constructor(props) {
    super(props);
    this.state = {
      notificationDetails: [],
      username: "",
      name: "",
      description: "",
      days: "",
      hours: "",
      email: "",
      configuration: "",
      status: "",
      updated: "",
      created: "",
      uniqueId:""
    };
    this.formSubmit = false;
  }

  async componentDidMount() {
    let notifcationId = this.props.match.params.id;
    let selectUrl = `${apiHost}/api/Notification/SelectNotification/${notifcationId}`;
    this.postNotificationDetails(selectUrl);
  }

  postNotificationDetails = async (url) => {
    this.props.setLoadingPageAction(true);
    try {
      const notificationDetails = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({ notificationDetails: notificationDetails.data });
      this.setState({
        userName: notificationDetails.data.userName,
        description: notificationDetails.data.description,
        name: notificationDetails.data.name,
        status: notificationDetails.data.status,
        updated: notificationDetails.data.dbUpdated,
        created: notificationDetails.data.dbCreated,
        configuration: notificationDetails.data.config,
        uniqueId: notificationDetails.data.uniqueId
      });

      console.log("eventDetails id", notificationDetails.data);
      this.handleConfiguration(notificationDetails.data.config);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };
  tConvert = (time) => {
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(""); // return adjusted time or original string
  };

  handleConfiguration = (config) => {
    let data = JSON.parse(config);
    let days = data.Days;

    let dayList = this.extractDays(days);

    let Hours = data.Hours;
    let startTimeHour = moment.utc(data.Period.Start).get("hour");
    let startTimeMinutes = moment.utc(data.Period.Start).get("minute");
    if (startTimeHour < 10) {
      startTimeHour = "0" + startTimeHour;
    }
    if (startTimeMinutes < 10) {
      startTimeMinutes = "0" + startTimeMinutes;
    }
    let Start = this.tConvert(`${startTimeHour}:${startTimeMinutes}`);
    let endTimeHour = moment.utc(data.Period.End).get("hour");
    let endTimeMinutes = moment.utc(data.Period.End).get("minute");
    if (endTimeHour < 10) {
      endTimeHour = "0" + endTimeHour;
    }
    if (endTimeMinutes < 10) {
      endTimeMinutes = "0" + endTimeMinutes;
    }
    let End = this.tConvert(`${endTimeHour}:${endTimeMinutes}`);

    let activeHours = this.handleActiveHour(Hours, Start, End);

    let Email = this.handleEmail(data.Email);
    this.setState({
      days: dayList,
      hours: activeHours,
      email: Email,
    });
  };
  handleEmail = (email) => {
    let emailDescription;
    if (email) {
      emailDescription = "Sent";
    } else {
      emailDescription = "Disabled";
    }
    return emailDescription;
  };

  handleActiveHour = (hours, start, end) => {
    let activeDescription;
    if (hours == 1) {
      activeDescription = "All day (24 hours) ";
    } else if (hours == 2) {
      activeDescription = "Events occuring within " + start + " and " + end;
    } else if ((hours = 3)) {
      activeDescription = "Events occuring outside " + start + " and " + end;
    }
    return activeDescription;
  };

  extractDays = (days) => {
    let DayArr = [];
    let j = 0;
    for (let i in days) {
      if (days[i]) {
        DayArr[j] = i.slice(0, 3);
        j++;
      }
    }

    for (let i in DayArr) {
      if (DayArr[i] == "Mon") {
        DayArr[i] = DayArr[0];
        DayArr[0] = "Mon";
      } else if (DayArr[i] == "Tue") {
        DayArr[i] = DayArr[1];
        DayArr[1] = "Tue";
      } else if (DayArr[i] == "Wed") {
        DayArr[i] = DayArr[2];
        DayArr[2] = "Wed";
      } else if (DayArr[i] == "Thu") {
        DayArr[i] = DayArr[3];
        DayArr[3] = "Thu";
      } else if (DayArr[i] == "Fri") {
        DayArr[i] = DayArr[4];
        DayArr[4] = "Fri";
      } else if (DayArr[i] == "Sat") {
        DayArr[i] = DayArr[5];
        DayArr[5] = "Sat";
      } else if (DayArr[i] == "Sun") {
        DayArr[i] = DayArr[6];
        DayArr[6] = "Sun";
      }
    }

    for (let i = 0; i < DayArr.length; i++) {
      if (typeof DayArr[i] != "undefined") {
        DayArr[i] = " " + DayArr[i];
      }
    }

    var filteredArr = DayArr.filter((el) => {
      return el != null;
    });

    return filteredArr;
  };

  render() {
    const {
      userName,
      name,
      days,
      hours,
      email,
      description,
      created,
      updated,
      status,
      uniqueId
    } = this.state;

    return (
      <div>
        <Layout>
          <Helmet>
            <title>Notification Details </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>Notification details</h2>
              <h6>{name}</h6>
              <hr></hr>
              <div className="notificationDetails">
                <div className="individualDetail">
                  <p className="left"> User</p>
                  <p className="right">{userName} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Name</p>
                  <p className="right">{name} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Notification #</p>
                  <p className="right">{uniqueId} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Description</p>
                  <p className="right">{description} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Days</p>
                  <p className="right">{days} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Hours</p>
                  <p className="right">{hours} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Email</p>
                  <p className="right">{email} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Status</p>
                  <p className="right">{status} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Updated</p>
                  <p className="right">{utcToLocal(updated)} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Created</p>
                  <p className="right">{utcToLocal(created)} </p>
                </div>
              </div>
              <br />
              <div className="footer-menu">
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => {
                    // this.props.history.push("/notifications");
                    this.props.history.goBack();
                  }}
                >
                  Back to List
                </Button>
                &nbsp;
                <Button
                  size="sm"
                  variant="primary"
                  onClick={() => {
                    this.props.history.push(
                      `/editNotification/${this.props.match.params.id}`
                    );
                  }}
                >
                  Edit
                </Button>
              </div>
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationDetails);
